














































































































































































import Vue, { PropType } from 'vue';
import moment from 'moment';
import AdBanner from '@/parts/util/AdBanner.vue';
import ReturnTop from "@/parts/util/ReturnTop.vue";
import VariableInput from '@/components/util/VariableInput.vue';
import { getUserNickName } from '@/utils/labelUtils';

import { UserProfile, ReportType, Type1 } from '@/api/dto/UserProfile';
import { getUsers } from '@/api/UserProfile';
import { UserSkill, GetUsersResponse } from '@/api/dto/UserProfile';
import { Language, Tool } from '@/api/dto/Skill';
import { createReport } from "@/api/Report";
import { defaultIconUrl } from '@/properties';

export default Vue.extend({
  name: '',
  components: {
    VariableInput,
    AdBanner,
    ReturnTop,
  },
  data() {
    return {
      defaultIconUrl,
      targetUser: {} as GetUsersResponse,
      submitModal: false,
      types: [
        { name: 'type1', value: '1', text: '性的、わいせつな表現' },
        { name: 'type2', value: '2', text: '反社会的、暴力的である' },
        { name: 'type3', value: '3', text: '出会い目的、勧誘' },
        { name: 'type4', value: '4', text: '迷惑行為' },
        { name: 'type5', value: '5', text: 'スパムや詐欺' },
        { name: 'type6', value: '6', text: 'プライバシーに関する内容を含む' },
        { name: 'type7', value: '7', text: '取引の放置' },
        { name: 'type8', value: '8', text: 'その他' },
      ],
      detailInput: '',
      selectType: '1',
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const res = await getUsers(to.params.userId);
      next(vm => vm.$data.targetUser = res);
    } catch (e) {
      next({ name: 'Top' });
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      const res = await getUsers(to.params.userId);
      this.targetUser = res;
      next();
    } catch (e) {
      next({ name: 'Top' });
    }
  },
  computed: {
    current: {
      get: function(): ReportType {
        return this.value;
      },
      set: function(val: ReportType) {
        this.selectType = val;
        this.$emit('input', val);
      },
    },
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    lastAccessFromNow(): string {
      return moment(this.targetUser.lastAccess).fromNow();
    },
    isSnsEmpty(): boolean {
      return !this.targetUser.twitterUsername && !this.targetUser.githubUsername && !this.targetUser.websiteUrl && !this.targetUser.publishedMailAddress;
    },
    isAffiliationEmpty(): boolean {
      return !this.targetUser.affiliationUrl && !this.targetUser.affiliation;
    },
    isSkillEmpty(): boolean {
      try {
        return !this.targetUser.skill.length;
      } catch (e) { // undefindが返ってくる対策
        return true;
      }
    },
    skillLanguage(): UserSkill[] {
      return this.targetUser.skill.filter(v => v.type === Language);
    },
    skillTool(): UserSkill[] {
      return this.targetUser.skill.filter(v => v.type === Tool);
    },
    nickname(): string {
      return getUserNickName(this.targetUser.nickname, this.targetUser.userId);
    }
  },
  props: {
    value: {
      type: String as PropType<ReportType>,
      default: Type1
    }
  },
  methods: {
    async submit() {
      try {
        await createReport({
          reporterUserId: this.loginData.userId,
          reportedUserId: this.targetUser.userId,
          reportType: this.selectType,
          text: this.detailInput,
        });
        this.detailInput = '';
        this.submitModal = false;
        this.$emit('toast', '通報が完了しました。');
      } catch (error) {
        this.detailInput = '';
        this.submitModal = false;
        this.$emit('errorToast', '通報の送信に失敗しました');
      }
    },
  }
})
